import { render, staticRenderFns } from "./AllModel.vue?vue&type=template&id=7c221d88&scoped=true&"
import script from "./AllModel.vue?vue&type=script&lang=js&"
export * from "./AllModel.vue?vue&type=script&lang=js&"
import style0 from "./AllModel.vue?vue&type=style&index=0&id=7c221d88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c221d88",
  null
  
)

export default component.exports